var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-pb_5" }, [
    _c("div", { staticClass: "emd-container _highlight_header" }, [
      _c("div", { staticClass: "emd-container__header" }, [
        _c("h2", { staticClass: "emd-text _size_default _type_caption" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("charge.detail.payer-details.title")) + " "
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "eu-pa_3 eu-mt_1" },
        _vm._l(_vm.transactionPayerTable, function (detailRow) {
          return _c(
            "div",
            {
              key: `details-row-${detailRow[0].key}`,
              staticClass: "el-grid-list eu-mb_3",
            },
            _vm._l(detailRow, function (detailCol) {
              return _c("div", { key: `details-col-${detailCol.key}` }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "emd-text _color_default _type_caption eu-mb_1 details-col",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(`charge.detail.payer-details.${detailCol.key}`)
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "p",
                  { staticClass: "`details-col-${ detailCol.key }-value`" },
                  [_vm._v(" " + _vm._s(detailCol.value) + " ")]
                ),
              ])
            }),
            0
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }